import { createPortal } from "react-dom";
import { formatMoney } from "@/lib/app-context";
import { monthLabel, fmtDate, balanceLabel } from "@/lib/sheet-utils";

const COLS = ["Month", "Days", "Earned", "B/F", "Bonus", "Advance", "Deduct", "Payable", "Paid", "Balance c/f", "Note"];

export function YearStatement({ data, currency }) {
  const { staff, year, months, totals, current_balance, current_month } = data;
  const m = (n) => formatMoney(n, currency);
  return createPortal(
    <div id="print-area" className="text-slate-900 text-[12px]" data-testid="year-statement-print">
      <div className="flex justify-between items-end border-b-2 border-slate-900 pb-2">
        <div className="text-2xl font-extrabold">Salary statement {year}</div>
        <div className="text-xs">Printed {fmtDate(new Date().toISOString().slice(0, 10))}</div>
      </div>
      <div className="grid grid-cols-4 gap-2 py-3">
        <div><div className="text-[10px] text-slate-500">Staff name</div><b>{staff.name}</b></div>
        <div><div className="text-[10px] text-slate-500">Agent name</div><b>{staff.agent_name || "—"}</b></div>
        <div><div className="text-[10px] text-slate-500">Date of joining</div><b>{fmtDate(staff.joining_date) || "—"}</b></div>
        <div><div className="text-[10px] text-slate-500">Monthly salary</div><b>{m(staff.base_salary)}</b></div>
      </div>
      <table className="w-full border-collapse">
        <thead><tr>{COLS.map((c) => <th key={c} className="border border-slate-400 px-1.5 py-1 text-left bg-slate-100">{c}</th>)}</tr></thead>
        <tbody>
          {months.map((r) => (
            <tr key={r.id}>
              {[monthLabel(r.month), r.days, m(r.earned), m(r.brought_forward), m(r.bonus || 0) + (r.bonus_type ? ` (${r.bonus_type})` : ""), m(r.advance), m(r.deduct), m(r.payable), m(r.paid_amount), m(r.balance), r.note || ""].map((v, i) => (
                <td key={i} className="border border-slate-300 px-1.5 py-1">{v}</td>
              ))}
            </tr>
          ))}
          <tr className="font-bold">
            <td className="border border-slate-400 px-1.5 py-1">Total</td><td className="border border-slate-400" />
            <td className="border border-slate-400 px-1.5 py-1">{m(totals.earned)}</td><td className="border border-slate-400" />
            <td className="border border-slate-400 px-1.5 py-1">{m(totals.bonus || 0)}</td>
            <td className="border border-slate-400 px-1.5 py-1">{m(totals.advance)}</td>
            <td className="border border-slate-400 px-1.5 py-1">{m(totals.deduct)}</td><td className="border border-slate-400" />
            <td className="border border-slate-400 px-1.5 py-1">{m(totals.paid_amount)}</td><td colSpan={2} className="border border-slate-400" />
          </tr>
        </tbody>
      </table>
      <div className="mt-3 text-sm font-bold">
        Current balance{current_month ? ` (${monthLabel(current_month)})` : ""}: {m(current_balance)} – {balanceLabel(current_balance)}
      </div>
      <div className="grid grid-cols-2 gap-16 mt-16 text-xs text-slate-500">
        <div className="border-t border-slate-400 pt-1">Employer signature</div>
        <div className="border-t border-slate-400 pt-1">Staff signature</div>
      </div>
    </div>,
    document.body,
  );
}
